import { Link } from "react-router-dom";
import useDepartmentDoctors from "../hooks/useDepartmentDoctors";
import DoctorCard from "./DoctorCard";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import { Phone, Mail, MapPin, CheckCircle2, Users, Award, Clock, Heart, Shield,ArrowRight } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import SEO from "../pages/SEO"
import { useAppointment } from "../context/AppointmentContext"
import Budensab from "../images/Dr Budensab Angadi.png"
import Aparna from "../images/Dr Lakshmi Aparna.png"
export default function PaediatricsPage() {
  const { open: openAppointment } = useAppointment();
  const doctors = useDepartmentDoctors("Pediatrics");


  const subspecialties = [
    {
      title: "General Paediatrics",
      description: "Fever, cold, cough, infections & childhood illnesses.",
      image: "/GeneralPaediatrics.jpg",
    },
    {
      title: "Paediatric Infectious Diseases",
      description: "Viral, bacterial, and seasonal infections.",
      image: "/PaediatricInfectiousDiseases.jpg",
    },
    {
      title: "Paediatric Gastroenterology",
      description: "Digestive issues, abdominal pain & nutritional care.",
      image: "/PaediatricGastroenterology.jpg",
    },
    {
      title: "Paediatric Endocrinology",
      description: "Growth disorders, thyroid problems & hormonal issues.",
      image: "/PaediatricEndocrinology.jpg",
    },
    {
      title: "Paediatric Allergy & Immunology",
      description: "Asthma, allergies, and immunity management.",
      image: "/PaediatricAllergy&Immunology.jpg",
    },
    {
      title: "Vaccination & Preventive Care",
      description: "Immunization for all age groups.",
      image: "/Vaccination&PreventiveCare.jpg",
    },
  ];

  const treatments = [
    "Treatment for Fevers, Infections & Allergies",
    "Asthma & Respiratory Illness Management",
    "Growth & Development Assessment",
    "Vaccinations & Immunization Programs",
    "Nutrition Counseling & Feeding Guidance",
    "Childhood Digestive Disorder Treatment",
    "Management of Chronic Pediatric Conditions",
    "Newborn Care & Early Development Support",
  ];

  const whyChoose = [
    {
      icon: Users,
      title: "Experienced Pediatricians",
      description: "Experienced pediatricians trained in child-friendly care",
    },
    {
      icon: Clock,
      title: "24/7 Emergency Services",
      description: "Dedicated Pediatric OPD & emergency services",
    },
    {
      icon: Shield,
      title: "Complete Vaccination Center",
      description: "Complete vaccination & immunization center",
    },
    {
      icon: Heart,
      title: "Growth Monitoring",
      description: "Growth monitoring, nutrition counseling & developmental care",
    },
    {
      icon: Award,
      title: "Integrated Support",
      description: "Integrated support with Neonatology & Pediatric Surgery",
    },
  ];
  const articles = [
    {
      title: "Common Childhood Illnesses Every Parent Should Be Aware Of",
      excerpt:
        "Learn about the most common childhood illnesses, their symptoms, and when to seek medical attention for your child.",
    },
    {
      title: "How to Boost Immunity in Children Naturally",
      excerpt:
        "Discover natural ways to strengthen your child's immune system through proper nutrition, sleep, and healthy habits.",
    },
    {
      title: "Importance of Timely Vaccination for Kids",
      excerpt:
        "Understand why vaccinations are crucial for your child's health and the recommended immunization schedule.",
    },
    {
      title: "Healthy Eating Habits for Growing Children",
      excerpt: "Essential nutrition tips and healthy eating habits to support your child's growth and development.",
    },
  ];
  const faqs = [
    {
      question: "What age group does Paediatrics cover?",
      answer:
        "Paediatrics covers healthcare for children from newborns to teenagers, typically from birth to 18 years of age. Our pediatricians are specially trained to address the unique medical needs of infants, children, and adolescents at every stage of their development.",
    },
    {
      question: "Do you provide vaccinations for children?",
      answer:
        "Yes, we offer all mandatory and optional vaccines as per the Indian Academy of Pediatrics (IAP) schedule. Our vaccination center provides comprehensive immunization services for children of all ages, along with proper documentation and follow-up care.",
    },
    {
      question: "Is pediatric emergency care available?",
      answer:
        "Yes, our pediatricians provide 24x7 emergency and acute illness care for children. We have a dedicated pediatric emergency team equipped to handle all types of childhood medical emergencies, from high fevers to respiratory distress and other urgent conditions.",
    },
  ];
  const schema = [
  {
    "@context": "https://schema.org",
    "@type": "MedicalClinic",
    "name": "MAMS Hospitals Paediatrics Department",
    "url": "https://mamshospitals.com/paediatrics",
    "logo": "https://mamshospitals.com/MAMS-Logo.png",
    "image": "https://mamshospitals.com/Paediatrics.jpg",
    "description": "MAMS Hospitals provides advanced paediatric treatment in Hyderabad including newborn care, vaccinations, pediatric emergency care, growth monitoring, asthma management, and child development services.",
    "medicalSpecialty": "Pediatrics",
    "telephone": "+91-7399999981",
    "priceRange": "$$",

    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Bachupally",
      "addressLocality": "Hyderabad",
      "addressRegion": "Telangana",
      "postalCode": "500090",
      "addressCountry": "IN"
    },

    "availableService": [
      {
        "@type": "MedicalProcedure",
        "name": "Child Vaccination & Immunization"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Newborn & Neonatal Care"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Pediatric Emergency Care"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Asthma & Allergy Management"
      },
      {
        "@type": "MedicalProcedure",
        "name": "Growth & Development Monitoring"
      }
    ],

    "sameAs": [
      "https://www.facebook.com/MAMSHospitals",
      "https://www.instagram.com/mams_hospitals"
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What age group does paediatrics cover?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Paediatrics covers healthcare for newborns, infants, children, and adolescents up to 18 years of age."
        }
      },
      {
        "@type": "Question",
        "name": "Do you provide vaccinations for children?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals provides all mandatory and optional child vaccinations as per pediatric immunization schedules."
        }
      },
      {
        "@type": "Question",
        "name": "Is pediatric emergency care available?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, MAMS Hospitals provides 24x7 pediatric emergency and acute illness care services."
        }
      }
    ]
  },

  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Paediatrics Department - MAMS Hospitals",
    "url": "https://mamshospitals.com/paediatrics",
    "description": "Best paediatrics hospital in Hyderabad offering child vaccination, newborn care, pediatric emergency care, asthma treatment, growth monitoring, and child wellness services.",
    "keywords": [
      "Best Pediatrician Hyderabad",
      "Paediatrics Hospital Hyderabad",
      "Child Specialist Hyderabad",
      "Vaccination Center Hyderabad",
      "Newborn Care Hyderabad",
      "Pediatric Emergency Hyderabad",
      "Paediatrics Hospital Bachupally"
    ]
  }
];

  return (
    <>
    <SEO
      title="Best Paediatrics Hospital in Hyderabad | Child Specialists | MAMS Hospitals"
      description="MAMS Hospitals offers advanced pediatric treatment in Hyderabad including newborn care, vaccinations, pediatric emergency care, asthma management, growth monitoring, and child wellness services."
      keywords="best pediatrician Hyderabad,
    paediatrics hospital Hyderabad,
    child specialist Hyderabad,
    vaccination center Hyderabad,
    newborn care Hyderabad,
    pediatric emergency Hyderabad,
    child doctor Hyderabad,
    pediatric asthma treatment Hyderabad,
    growth monitoring Hyderabad,
    child vaccination Hyderabad,
    neonatal care Hyderabad,
    paediatrics hospital Bachupally,
    MAMS Hospitals Paediatrics"
      schema={schema}
    />
    <div className="flex flex-col min-h-screen">

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-teal-50 via-white to-blue-50 py-12 md:py-24">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
                Best Paediatrics Hospital in Hyderabad
              </div>
              <h1 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
                Your Heart, Our Priority - Comprehensive Child Care
              </h1>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                MAMS Hospitals is recognized as one of the Best Paediatrics Hospitals in Hyderabad, providing
                comprehensive healthcare for newborns, infants, children, and adolescents. From common childhood
                illnesses to complex pediatric conditions, our expert pediatricians deliver gentle, evidence-based, and
                child-friendly medical care.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">

                <Button className="bg-teal-600 hover:bg-teal-700 text-white rounded-full px-8" size="lg" onClick={openAppointment}>
                    Book Appointment
                  </Button>

                <Link to="tel:+91-7399999981">
                  <Button
                    className="border-teal-600 text-teal-600 hover:bg-teal-50 rounded-full px-8"
                    variant="outline"
                    size="lg"
                  >
                    <Phone className="mr-2 h-5 w-5" />
                    Call Us
                  </Button>
                </Link>

              </div>
            </div>

            <div className="relative">
              <div className="absolute -top-4 -right-4 bg-teal-600 text-white p-6 rounded-2xl shadow-xl z-10">
                <div className="text-3xl font-bold">24/7</div>
                <div className="text-sm">Emergency Care</div>
              </div>
              <img
                src="/Paediatrics.jpg"
                alt="Paediatrics at MAMS Hospital"
                className="rounded-2xl shadow-2xl w-full"
              canonicalUrl="https://mamshospitals.com/departments/paediatrics"
      />
            </div>
          </div>
        </div>
      </section>

      {/* Sub-Specialties Section */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Sub-Specialities in Paediatrics</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Comprehensive pediatric care across multiple specializations
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {subspecialties.map((specialty, index) => (
              <Card
                key={index}
                className="group hover:shadow-xl transition-all duration-300 border-gray-200 hover:border-teal-500"
              >
                <CardContent className="p-0">
                  <div className="relative h-48 overflow-hidden rounded-t-lg">
                    <img
                      src={specialty.image || "/placeholder.svg"}
                      alt={specialty.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-bold text-gray-900 mb-3">{specialty.title}</h3>
                    <p className="text-gray-600 leading-relaxed">{specialty.description}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Treatments */}
      <section className="py-16 md:py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Treatments & Procedures</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Comprehensive pediatric treatments for every stage of childhood
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            {treatments.map((treatment, index) => (
              <div key={index} className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm">
                <CheckCircle2 className="h-6 w-6 text-teal-600 flex-shrink-0 mt-1" />
                <span className="text-gray-700 font-medium">{treatment}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose */}
      <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              Why Choose MAMS Hospitals for Paediatrics
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Trusted pediatric excellence with child-centered care
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {whyChoose.map((item, index) => (
              <Card key={index} className="border-gray-200 hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="w-14 h-14 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                    <item.icon className="h-7 w-7 text-teal-600" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{item.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* <div className="mt-12 text-center">
            <p className="text-gray-600 mb-2">Easily accessible location near Miyapur & Bachupally</p>
          </div> */}
        </div>
      </section>

      {/* Meet Specialist */}
                {doctors.length > 0 && (
          <section className="py-16 px-0 bg-apple-gray-50">
            <div className="container mx-auto max-w-6xl">
              <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-semibold text-apple-gray-500 mb-4">Meet Our Specialists</h2>
              </div>
              <div className="relative">
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: -340, behavior: 'smooth' }); }}
                  className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" /></svg>
                </button>
                <div id="doc-scroll" className="flex gap-6 overflow-x-auto scroll-smooth px-10 scrollbar-hide pb-4">
                  {doctors.map(doctor => (
                    <div key={doctor.id} className="w-[280px] sm:w-[300px] flex-shrink-0">
                      <DoctorCard doctor={{
                        name: doctor.title.rendered,
                        slug: doctor.slug,
                        imageUrl: doctor._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
                        specialty: doctor._embedded?.["wp:term"]?.[0]?.[0]?.name || "",
                        designation: doctor.acf?.designation || "",
                        qualification: doctor.acf?.qualification || "",
                        experience: doctor.acf?.experience || "",
                      }} />
                    </div>
                  ))}
                </div>
                <button
                  onClick={() => { const el = document.getElementById('doc-scroll'); if(el) el.scrollBy({ left: 340, behavior: 'smooth' }); }}
                  className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white shadow-md rounded-full p-2 hover:bg-gray-100"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" /></svg>
                </button>
              </div>
              <div className="text-center mt-8">
                <Link to="/doctors">
                  <button className="px-6 py-3 rounded-full border text-sm font-medium inline-flex items-center gap-2">
                    View All Doctors
                  </button>
                </Link>
              </div>
            </div>
          </section>
          )}

      {/* Articles */}
      {/* <section className="py-16 md:py-20 bg-white">
        <div className="container mx-auto px-0 max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Recent Articles</h2>
            <p className="text-lg text-gray-600">Stay informed about child health and wellness</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {articles.map((article, index) => (
              <Card
                key={index}
                className="group hover:shadow-xl transition-all duration-300 cursor-pointer border-gray-200"
              >
                <CardContent className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">{article.excerpt}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section> */}

      {/* FAQ */}
      <section className="py-16 md:py-20 bg-gray-50">
        <div className="container mx-auto px-0 max-w-4xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
            <p className="text-lg text-gray-600">Get answers to common questions about pediatric care</p>
          </div>

          <Accordion type="single" collapsible className="bg-white rounded-lg shadow-sm">
            {faqs.map((faq, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left px-6 hover:text-teal-600">{faq.question}</AccordionTrigger>
                <AccordionContent className="px-6 text-gray-600 leading-relaxed">{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* Contact & Appointment Section */}
      <section className="py-16 px-0 bg-apple-teal text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-semibold mb-4">Book an Appointment</h2>
            <p className="text-white/90 max-w-2xl mx-auto">
              Your heart health is our top priority. Book an appointment today with Hyderabad's trusted experts at MAMS Hospitals
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Phone className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Call Us</h3>
                <a href="tel:+917399999981" className="text-white/90 hover:text-white">
                  +91-7399999981
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <Mail className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Email Us</h3>
                <a href="mailto: info@mamshospitals.com" className="text-white/90 hover:text-white">
                   info@mamshospitals.com
                </a>
              </CardContent>
            </Card>

            <Card className="bg-white/10 backdrop-blur-sm border-white/20 rounded-3xl">
              <CardContent className="p-6 text-center">
                <MapPin className="h-8 w-8 mx-auto mb-4 text-white" />
                <h3 class="font-bold text-white mb-2">Visit Us</h3>
                <p className="text-white/90">Bachupally, Miyapur</p>
              </CardContent>
            </Card>
          </div>

          <div className="text-center">
            {/* <Link href="/book-appointment">
              <Button size="lg" variant="secondary" className="rounded-full">
                <Calendar className="mr-2 h-5 w-5" />
                Schedule Your Appointment
              </Button>
            </Link> */}
          </div>
        </div>
      </section>

      {/* Emergency Banner */}
      <section className="py-8 px-0 bg-red-600 text-white">
        <div className="container mx-auto max-w-6xl">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="flex items-center gap-4">
              <Clock className="h-8 w-8" />
              <div>
                <h3 className="text-xl font-bold">24/7 Emergency Care</h3>
                <p className="text-white/90">Fully equipped emergency department</p>
              </div>
            </div>
            <a href="tel:+917399999981">
              <Button size="lg" variant="secondary" className="w-full sm:w-auto rounded-full bg-white text-red-600 hover:bg-gray-100">
                <Phone className="mr-2 h-5 w-5" />
                Call Emergency
              </Button>
            </a>
          </div>
        </div>
      </section>

    </div>
    </>
  );
}
